import React from 'react';
import { Paper, CardContent, Grid, Typography, Box } from '@material-ui/core';
import useStyles from './sampleDevelopmentNl.style';
import SampleDevelopmentNlPackingProduct from './SampleDevelopmentNlPackingProduct';
import SampleDevelopmentNlPackingCarton from './SampleDevelopmentNlPackingCarton';

interface SampleDevelopmentNlPackingProps {
  isCrtLocked?: boolean;
}

const SampleDevelopmentNlPacking: React.FC<SampleDevelopmentNlPackingProps> = (props) => {
  const { isCrtLocked = false } = props;
  const classes = useStyles();

  return (
    <Paper variant="outlined">
      <CardContent>
        <Grid container spacing={1} direction="row" justifyContent="flex-start">
          <Grid container>
            <Typography className={classes.title}>Packing & QC</Typography>
          </Grid>
          <Box m={1}>
            <SampleDevelopmentNlPackingProduct isCrtLocked={isCrtLocked} />
            <SampleDevelopmentNlPackingCarton isCrtLocked={isCrtLocked} />
          </Box>
        </Grid>
      </CardContent>
    </Paper>
  );
};

export default SampleDevelopmentNlPacking;
